import React, { useState } from 'react';
import { api } from '../../api/client';

import { ta, taf } from '../../i18n/adminT';
const DOC_TYPE_LABELS = {
  carta_identita: "Carta d'identità",
  patente: 'Patente',
  passaporto: 'Passaporto',
};

function Row({ label, value }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, padding: '8px 0', borderBottom: '1px solid var(--border-hair)' }}>
      <span style={{ color: 'var(--muted-text)', fontSize: '0.85rem' }}>{label}</span>
      <span style={{ textAlign: 'right' }}>{value || <span style={{ color: 'var(--muted-text)' }}>—</span>}</span>
    </div>
  );
}

export default function ExternalUserDetailModal({ user, onClose, onRegenerated }) {
  const [current, setCurrent] = useState(user);
  const [regenerating, setRegenerating] = useState(false);
  const [error, setError] = useState('');

  const handleRegenerate = async () => {
    if (!window.confirm(taf('Generare un nuovo codice di riserva per {nome}? Il vecchio codice ({codice}) smetterà di funzionare.', { nome: `${current.nome} ${current.cognome}`, codice: current.unique_code }))) return;
    setError('');
    setRegenerating(true);
    try {
      const res = await api.regenerateExternalCode(current.id);
      setCurrent({ ...current, unique_code: res.data.unique_code });
      onRegenerated?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setRegenerating(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h2>{current.nome} {current.cognome}</h2>

        {error && <div className="form-error">{error}</div>}

        <div style={{ marginTop: 8 }}>
          <Row label={ta('Ditta')} value={current.ditta} />
          <Row
            label={ta('Documento')}
            value={current.tipo_documento ? `${ta(DOC_TYPE_LABELS[current.tipo_documento])}${current.numero_documento ? ' · ' + current.numero_documento : ''}` : null}
          />
          <Row label={ta('Badge NFC')} value={current.nfc_uid} />
          <Row label={ta('Codice di riserva')} value={<span className="mono">{current.unique_code}</span>} />
          <Row label={ta('Email')} value={current.email} />
          {current.email && (
            <Row label={ta('Invio email a ogni check-in')} value={current.send_checkin_email === false ? ta('Disattivato') : ta('Attivo')} />
          )}
          <Row
            label={ta('Persone di riferimento')}
            value={current.references && current.references.length > 0 ? current.references.map((r) => `${r.nome} ${r.cognome}`).join(', ') : null}
          />
        </div>

        <div className="btn-row" style={{ marginTop: 20 }}>
          <button type="button" className="btn btn-ghost" onClick={handleRegenerate} disabled={regenerating}>
            {regenerating ? ta('Generazione…') : ta('Genera nuovo codice')}
          </button>
          <button type="button" className="btn btn-primary" onClick={onClose}>{ta('Chiudi')}</button>
        </div>
      </div>
    </div>
  );
}
